import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FiltersModel, CustomerModel } from '@kanzi-apes/kanzi-models';
import moment from 'moment';

@Component({
    selector: 'lib-kanzi-returns-items-count',
    templateUrl: './kanzi-returns-items-count.component.html',
    styleUrls: ['./kanzi-returns-items-count.component.scss'],
    standalone: false
})
export class KanziReturnsItemsCountComponent implements OnInit, OnChanges {
  @Input() customer!: CustomerModel;

  validationType1: string = '';
  validationType2: string = '';

  description1: string = '';
  description2: string = '';

  path: string = '';
  filter1!: FiltersModel;
  filter2!: FiltersModel;
  today = Date.now();
  monthName: string = '';
  constructor() {}

  ngOnInit(): void {}

  ngOnChanges() {
    this.monthName = moment(new Date()).startOf('month').format('MMMM');
    this.validationType1 = 'primary';
    this.validationType2 = 'success';
    this.description1 = `Total ${this.monthName}`;
    this.description2 = 'Total';
    if (this.customer) {
      this.path = 'inventory/traces/';
      const minDate = moment(new Date()).startOf('month').format('YYYY-MM-DD');
      const maxDate = moment(new Date()).endOf('month').format('YYYY-MM-DD');
      this.filter1 = {
        customer_id: this.customer.id,
        page: 1,
        page_size: 1,
        action: 'RETURN',
        created_min: minDate,
        created_max: maxDate,
      };
      this.filter2 = {
        customer_id: this.customer.id,
        page: 1,
        page_size: 1,
        action: 'RETURN',
      };
    } else {
      this.path = 'inventory/traces/';
      const minDate = moment(new Date()).startOf('month').format('YYYY-MM-DD');
      const maxDate = moment(new Date()).endOf('month').format('YYYY-MM-DD');
      this.filter1 = {
        page: 1,
        page_size: 1,
        action: 'RETURN',
        created_min: minDate,
        created_max: maxDate,
      };
      this.filter2 = {
        page: 1,
        page_size: 1,
        action: 'RETURN',
      };
    }
  }
}
